import styled from "styled-components";

export const CloseSpan = styled.span`
  margin: 0 10px;
  padding: 5px;
  cursor: pointer;
`;
